export enum ExtractionProcessFlows{
	LYSIS_EXT_HAIR = "LYSIS_EXT_HAIR",
	LYSIS_EXT_EARTAG = "LYSIS_EXT_EARTAG",
	EXT_EARTAG_TLR = "EXT_EARTAG_TLR"
}

export enum BeadChipProcessFlows{
	OLD_FLOW = "OLD_FLOW",
	AXIOM_384 = "AXIOM_384"
}